module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-17 at 11.31.47.0c83b3a5.png";